import { LeagueMarketCategory } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const leagueMarketCategoryDictionary = createSimpleDictionary([
    { id: LeagueMarketCategory.MicroEff, name: 'dictionaries.clMarketCategory.microEff' },
    { id: LeagueMarketCategory.LowEff, name: 'dictionaries.clMarketCategory.lowEff' },
    { id: LeagueMarketCategory.YouthEff, name: 'dictionaries.clMarketCategory.youthEff' },
    { id: LeagueMarketCategory.KidEff, name: 'dictionaries.clMarketCategory.kidEff' },
    { id: LeagueMarketCategory.IntEff, name: 'dictionaries.clMarketCategory.intEff' },
    { id: LeagueMarketCategory.CfriEff, name: 'dictionaries.clMarketCategory.cfriEff' },
    { id: LeagueMarketCategory.FanEff, name: 'dictionaries.clMarketCategory.fanEff' },
    { id: LeagueMarketCategory.MedEff, name: 'dictionaries.clMarketCategory.medEff' },
    { id: LeagueMarketCategory.ProEff, name: 'dictionaries.clMarketCategory.proEff' },
]);
